import * as React from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { TimesheetEstimatedTimeFragment } from 'generated/resources/graphql'

import type Store from 'modules/attendance/components/ClockIn/Store'
import { OvertimePoolsCollection } from 'modules/attendance/hooks/OvertimePoolsCollection'
import { SidePanelTab } from 'modules/attendance/lib/sidepanelTabTypes'
import { AggregatedWorkedTimeBlocks } from 'modules/attendance/lib/utils/AttendanceWorkedTimeUtils'
import { TimeBlocksBalanceCollection } from 'modules/attendance/store/models/TimeBlocksBalanceCollection'

import Balance from './Balance'
import Compensation from './Compensation'
import Worked from './Worked'

type Props = {
  selectedTab: SidePanelTab
  overtimePools: OvertimePoolsCollection
  timeBlocksBalance: TimeBlocksBalanceCollection
  employeeId: number
  store: Store
  workedTime?: AggregatedWorkedTimeBlocks | null
  estimatedTimes: TimesheetEstimatedTimeFragment[]
  loading: boolean
  payrollCompensationEnabled: boolean
  timeoffCompensationEnabled: boolean
}

const EmployeeTimeTrackingBreakdown = ({
  selectedTab,
  overtimePools,
  timeBlocksBalance,
  workedTime,
  estimatedTimes,
  store,
  loading,
  payrollCompensationEnabled,
  timeoffCompensationEnabled,
}: Props) => {
  if (loading)
    return (
      <Box width="full" paddingTop="s40" alignItems="center" justifyContent="center">
        <Spinner />
      </Box>
    )

  switch (selectedTab) {
    case 'worked_hours':
      return (
        <Worked workedTimeForEmployee={workedTime} estimatedTimes={estimatedTimes} store={store} />
      )
    case 'balance':
      return (
        <Balance
          overtimePools={overtimePools}
          timeBlocksBalance={timeBlocksBalance}
          payrollCompensationEnabled={payrollCompensationEnabled}
          timeoffCompensationEnabled={timeoffCompensationEnabled}
          workedTimeForEmployee={workedTime}
        />
      )
    case 'compensation':
      return <Compensation timeBlocksBalance={timeBlocksBalance} />
    case 'bank_of_hours':
      return
    default:
      const exhaustiveCheck: never = selectedTab
      throw new Error(`Unhandled SidePanelTab value: ${exhaustiveCheck}`)
  }
}

export default EmployeeTimeTrackingBreakdown
